import {useQuery} from '@tanstack/react-query';
import Group from 'src/core/models/group';
import GroupService from 'src/services/group-service';

export const groupKeys = {
  all: ['groups'],
};

export const useGroups = () => {
  const groupsService = new GroupService();

  return useQuery<unknown, unknown, Group[]>({
    queryKey: groupKeys.all,
    queryFn: () => groupsService.list(),
    initialData: [],
  });
};
